import React from 'react';
import '../Styles/SocialsIconBar.css';
import discord from '../../Assets/icons/discord.svg'
import email from '../../Assets/icons/email.svg'
import fb from '../../Assets/icons/facebook.svg'
import instagram from '../../Assets/icons/instagram.svg'
import linkedin from '../../Assets/icons/linkedin.svg'

const SocialsIconBar = () => {
  return (
    <div class="fixed-icon-bar">
        <a href="https://discord.gg/mgPQ97JHJb" target="_blank">
            <img src={discord} alt="Discord" class="socials-icon"/>
        </a>
        <a href="https://www.linkedin.com/company/western-csus/" target="_blank">
            <img src={linkedin} alt="LinkedIn" class="socials-icon"/>
        </a>
        <a href="https://www.instagram.com/westerncsus/" target="_blank">
            <img src={instagram} alt="Instagram" class="socials-icon"/>
        </a>
        <a href="https://www.facebook.com/westerncsus" target="_blank">
            <img src={fb} alt="Facebook" class="socials-icon"/>
        </a>
        <a href="mailto:csusuwo@gmail.com" target="_blank">
            <img src={email} alt="Email" class="socials-icon"/>
        </a>
    </div>

  );
};

export default SocialsIconBar;